import React, { useContext, useEffect, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';

function AgentDropdown({
	showDropdown,
	setShowDropdown,
	agentSelected,
	setAgentSelected,
	setAgentIdSelected,
}) {
	const { firebase } = useContext(FirebaseContext);
	const [agentsList, setAgentsList] = useState();

	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents/')
			.once('value', (snapshot) => {
				var agentsArr = [];
				snapshot.forEach((snap) => {
					var agentName = snap.val().name;
					var agentId = snap.val().createrID;

					var agentObj = {
						agentName: agentName,
						agentId: agentId,
					};

					agentsArr.push(agentObj);
				});

				console.log('agentsArr: ' + agentsArr);

				setAgentsList(agentsArr);
			});
	}, []);

	return (
		<div className='agent_selector'>
			<h3>Please choose your agent: </h3>
			<div className='agent_selector_dropdown'>
				<button
					onClick={() => setShowDropdown(true)}
					className='agent_selector_dropdown_btn'
				>
					<div id='dropdown_title'>
						{agentSelected ? agentSelected : 'Select your agent'}
					</div>
					<div id='dropdown_icon'>
						<ExpandMoreIcon />
					</div>
				</button>
				<div
					id='agent_dropdown'
					className={
						showDropdown === true
							? 'agent_dropdown_content show'
							: 'agent_dropdown_content'
					}
				>
					{agentsList?.map((agent) => (
						<a
							onClick={(e) => {
								setShowDropdown(false);
								setAgentSelected(e.target.text);
								setAgentIdSelected(e.currentTarget.dataset.id);
							}}
							data-id={agent.agentId}
						>
							{agent.agentName}
						</a>
					))}
				</div>
			</div>
		</div>
	);
}

export default AgentDropdown;
